import { listen, qs, remove } from "@fluorescent/dom";

export default function (container) {
  const recipientFormContainer = qs(
    ".product-form__gift-card-recipient",
    container
  );

  if (!recipientFormContainer) return;

  const sectionID = recipientFormContainer.dataset.sectionId;

  const selectors = {
    enableInput: `#gift-card-recipient-enable--${sectionID}`,
    recipientForm: ".gift-card-recipient-fields",
    emailLabelOptional: ".gift-card-recipient-email-label .optional",
    emailLabelRequired: ".gift-card-recipient-email-label .required",
    emailInput: `#gift-card-recipient-email--${sectionID}`,
    nameInput: `#gift-card-recipient-name--${sectionID}`,
    messageInput: `#gift-card-recipient-message--${sectionID}`,
    sendOnInput: `#gift-card-recipient-send_on--${sectionID}`,
    controlInput: `#gift-card-recipient-control--${sectionID}`,
    offsetInput: `#gift-card-recipient-timezone-offset--${sectionID}`,
    errors: ".gift-card-recipient__form-errors",
  };

  const elements = {
    enableInput: qs(selectors.enableInput, recipientFormContainer),
    emailLabelOptional: qs(
      selectors.emailLabelOptional,
      recipientFormContainer
    ),
    emailLabelRequired: qs(
      selectors.emailLabelRequired,
      recipientFormContainer
    ),
    emailInput: qs(selectors.emailInput, recipientFormContainer),
    nameInput: qs(selectors.nameInput, recipientFormContainer),
    messageInput: qs(selectors.messageInput, recipientFormContainer),
    sendOnInput: qs(selectors.sendOnInput, recipientFormContainer),
    controlInput: qs(selectors.controlInput, recipientFormContainer),
    offsetInput: qs(selectors.offsetInput, recipientFormContainer),
    recipientForm: qs(selectors.recipientForm, recipientFormContainer),
    errors: qs(selectors.errors, recipientFormContainer),
    errorList: qs(`${selectors.errors} ul`, recipientFormContainer),
  };

  const getInputs = () => {
    return [
      elements.emailInput,
      elements.nameInput,
      elements.messageInput,
      elements.sendOnInput,
    ];
  };

  const disableableInputs = () => {
    return [...getInputs(), elements.offsetInput];
  };

  const disableInputs = (inputs, disable) => {
    inputs.forEach(input => {
      input.disabled = disable;
    });
  };

  const clearInputs = inputs => {
    inputs.forEach(input => {
      input.value = "";
    });
  };

  const handleChange = e => {
    const el = e.target;

    if (el.type === "checkbox") {
      if (el.checked) {
        elements.recipientForm.hidden = false;
      } else {
        clearInputs(getInputs());
        elements.recipientForm.hidden = true;
        elements.errors.hidden = true;
        elements.errorList.replaceChildren();

        getInputs().forEach(input => {
          remove(input, "input-error");
        });
      }

      disableInputs(disableableInputs(), !el.checked);
    } else {
      remove(el, "input-error");
    }
  };

  // Hide form by default
  elements.recipientForm.hidden = true;

  // Disable control input and enable the enable input
  elements.controlInput.disabled = true;
  elements.enableInput.disabled = false;

  // Disable form inputs by default
  disableInputs(disableableInputs(), true);

  // Remove "optional" from email label/placeholder
  elements.emailInput.placeholder =
    elements.emailInput.dataset.placeholderRequired;
  elements.emailLabelOptional.hidden = true;
  elements.emailLabelRequired.hidden = false;

  elements.offsetInput.value = new Date().getTimezoneOffset();

  // Set up listeners for the display inputs
  const events = [listen(elements.enableInput, "change", handleChange)];

  // Clear errors
  getInputs().forEach(input => {
    events.push(listen(input, "input", handleChange));
  });

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
  };

  return { unload };
}
